import { Box, Collapse, IconButton as MuiIconButton } from "@mui/material";
import { ReactComponent as KeyboardArrowDown } from "assets/icon/keyboardArrowDown.svg";
import { ReactComponent as KeyboardArrowRight } from "assets/icon/keyboardArrowRight.svg";
import Label from "components/LabelInput/Label";
import NormalBtn from "components/NewButton/NormalBtn";
import { useEffect, useState } from "react";
import SearchDetailMbshpContents from "./SearchDetailMbshpContents";
import SearchDetailMemberContents from "./SearchDetailMemberContents";
import SearchDetailPtContents from "./SearchDetailPtContents";
import SearchDetailSideContents from "./SearchDetailSideContents";

const SearchDetailArea = (props) => {
  const {
    searchParam,
    setSearchParam,
    detailOption,
    setDetailOption,
    openSearchDetail,
    setOpenSearchDetail,
    onChangeDetailOption,
  } = props;

  const [searchDetailTitle, setSearchDetailTitle] = useState("기준별 검색 조건");

  useEffect(() => {
    onSelectDetailOpt(detailOption);
  }, [detailOption]);

  const onSelectDetailOpt = (option) => {
    switch (option) {
      case "member":
        setSearchDetailTitle("기준별 검색 조건 : 회원");
        break;
      case "mbshp":
        setSearchDetailTitle("기준별 검색 조건 : 회원권");
        break;
      case "pt":
        setSearchDetailTitle("기준별 검색 조건 : PT");
        break;
      case "side":
        setSearchDetailTitle("기준별 검색 조건 : 부가상품");
        break;
      case "locker":
        setSearchDetailTitle("기준별 검색 조건 : 부가상품");
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Box
        sx={{
          border: "1px solid #dedede",
          borderRadius: "5px",
          backgroundColor: "#f5f5f5",
        }}
      >
        <div
          style={{ display: "flex" }}
          onClick={() => {
            setOpenSearchDetail(!openSearchDetail);
          }}
        >
          <MuiIconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              setOpenSearchDetail(!openSearchDetail);
            }}
          >
            {openSearchDetail ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
          </MuiIconButton>
          <Label labelText={searchDetailTitle} />
        </div>

        <Collapse in={openSearchDetail} timeout="auto" unmountOnExit>
          <div style={{ margin: "0.75rem 0.5rem" }}>
            <div style={{ display: "flex" }}>
              <NormalBtn
                name="회원"
                width="4.875rem"
                borderRadius="0.3125rem 0 0 0.3125rem"
                isHover
                theme={detailOption === "member" ? "grpActive" : "grpDeactive"}
                onClick={() => {
                  setSearchParam((prev) => {
                    return {
                      ...prev,
                      pending: true,
                    };
                  });
                  onChangeDetailOption("member");
                  setDetailOption("member");
                }}
              />

              <NormalBtn
                name="회원권"
                width="4.875rem"
                radiusNone
                isHover
                theme={detailOption === "mbshp" ? "grpActive" : "grpDeactive"}
                onClick={() => {
                  setSearchParam((prev) => {
                    return {
                      ...prev,
                      pending: true,
                    };
                  });
                  onChangeDetailOption("mbshp");
                  setDetailOption("mbshp");
                }}
              />

              <NormalBtn
                name="PT"
                width="4.875rem"
                radiusNone
                isHover
                theme={detailOption === "pt" ? "grpActive" : "grpDeactive"}
                onClick={() => {
                  setSearchParam((prev) => {
                    return {
                      ...prev,
                      pending: true,
                    };
                  });
                  onChangeDetailOption("pt");
                  setDetailOption("pt");
                }}
              />
              <NormalBtn
                name="부가상품"
                width="4.875rem"
                borderRadius="0 0.3125rem 0.3125rem 0"
                isHover
                theme={
                  detailOption === "side" || detailOption === "locker" ? "grpActive" : "grpDeactive"
                }
                onClick={() => {
                  setSearchParam((prev) => {
                    return {
                      ...prev,
                      pending: true,
                    };
                  });
                  onChangeDetailOption("side");
                  setDetailOption("side");
                }}
              />
            </div>

            <div style={{ marginTop: "1.25rem" }}>
              {detailOption === "member" ? (
                <SearchDetailMemberContents searchParam={searchParam} />
              ) : detailOption === "mbshp" ? (
                <SearchDetailMbshpContents searchParam={searchParam} />
              ) : detailOption === "pt" ? (
                <SearchDetailPtContents searchParam={searchParam} />
              ) : detailOption === "side" || detailOption === "locker" ? (
                <SearchDetailSideContents
                  searchParam={searchParam}
                  setDetailOption={setDetailOption}
                />
              ) : (
                <div>
                  <Label
                    labelText="상세 검색 기준을 선택해주세요"
                    color="#777"
                    marginTop="5rem"
                    marginBottom="5rem"
                  />
                </div>
              )}
            </div>
          </div>
        </Collapse>
      </Box>
    </>
  );
};
export default SearchDetailArea;
